/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedWordpressArticles_itemSearch = {
    readonly editorialArticles: {
        readonly totalResults: number | null;
        readonly " $fragmentRefs": FragmentRefs<"EditorialModule_editorialArticles">;
    } | null;
    readonly " $refType": "SbSharedWordpressArticles_itemSearch";
};
export type SbSharedWordpressArticles_itemSearch$data = SbSharedWordpressArticles_itemSearch;
export type SbSharedWordpressArticles_itemSearch$key = {
    readonly " $data"?: SbSharedWordpressArticles_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedWordpressArticles_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedWordpressArticles_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "editorialArticles",
      "storageKey": "editorialArticles(first:2)",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2
        }
      ],
      "concreteType": "WordpressArticlesType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalResults",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "EditorialModule_editorialArticles",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'd01fd73f275c6436e50354679dafae67';
export default node;
